/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  // Smart sticky header: visible on scroll-up, hidden on scroll-down
  var customStickyHeader = document.querySelector('[data-header-custom-sticky]');
  if (customStickyHeader) {
    document.body.classList.add('has-header-sticky');

    var state = 'inactive'; // 'inactive' | 'fixed' | 'hidden'
    var idleTimer = null;
    var headerSection = customStickyHeader.closest('.page-header') || customStickyHeader.parentElement;
    var headerSections = document.querySelector('.header-sections');

    var headerSectionHeight = headerSection ? headerSection.offsetHeight : 0;
    var announcementHeight = 0;
    if (headerSection && headerSections) {
      var hRect = headerSection.getBoundingClientRect();
      var pRect = headerSections.getBoundingClientRect();
      announcementHeight = Math.max(0, Math.round(hRect.top - pRect.top));
    }

    // Valeurs dynamiques → custom properties CSS (tout le reste est géré par les classes)
    document.documentElement.style.setProperty('--sticky-announcement-height', announcementHeight + 'px');
    document.documentElement.style.setProperty('--sticky-header-height', headerSectionHeight + 'px');
    document.documentElement.style.setProperty('--sticky-container-height', (announcementHeight + headerSectionHeight) + 'px');

    if (headerSection) headerSection.classList.add('is-custom-sticky-init');
    if (headerSections) headerSections.classList.add('is-custom-sticky-container');

    var headerNaturalTop = announcementHeight;

    // Keep the cart pill visible at all times. The header both fades (opacity:0 on
    // [data-header-custom-sticky]) AND scrolls away with .page-header when the sticky
    // goes idle — so neither the wrapper nor .page-header can host an always-visible
    // pill. Move it to <body> and pin it with position:fixed (see custom.css).
    var cartPill = customStickyHeader.querySelector('.header__cart--pill');
    if (cartPill && !cartPill.classList.contains('header__cart--pill-detached')) {
      document.body.appendChild(cartPill);
      cartPill.classList.add('header__cart--pill-detached');
    }

    // On load we're at the top of the page → account for the announcement bar
    if (window.scrollY <= headerNaturalTop) {
      document.body.classList.add('header-at-top');
    }

    function setState(newState) {
      state = newState;
      if (newState === 'fixed') {
        if (headerSection) headerSection.classList.add('is-sticky-section-active');
        customStickyHeader.classList.remove('is-sticky-hidden');
      } else if (newState === 'hidden') {
        customStickyHeader.classList.add('is-sticky-hidden');
      } else {
        // inactive → retour en absolute (is-custom-sticky-init reprend la main)
        if (headerSection) headerSection.classList.remove('is-sticky-section-active');
        customStickyHeader.classList.remove('is-sticky-hidden');
      }
    }

    document.addEventListener('theme:scroll', function(e) {
      var scrollingDown = e.detail.down;
      var position = e.detail.position;

      if (position <= headerNaturalTop) {
        if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; }
        if (state !== 'inactive') setState('inactive');
        // Top of page: header visible below the announcement bar → pill accounts for it
        document.body.classList.remove('header-hidden');
        document.body.classList.add('header-at-top');
        return;
      }

      // Scrolled past the top → the announcement bar is gone
      document.body.classList.remove('header-at-top');

      if (!scrollingDown) {
        if (idleTimer) { clearTimeout(idleTimer); idleTimer = null; }
        setState('fixed');
        // Header revealed → pill back below the header
        document.body.classList.remove('header-hidden');
      } else {
        // Scrolling down past the top → menu masked (either the pinned header hides, or
        // it simply scrolled away). Raise the pill to header level in every case.
        if (state === 'fixed') {
          setState('hidden');
          idleTimer = setTimeout(function() {
            idleTimer = null;
            if (state === 'hidden') setState('inactive');
          }, 350);
        }
        document.body.classList.add('header-hidden');
      }
    });
  }

  // Blog listing: category filter buttons (metaobject custom.category). Clicking a
  // button shows only the matching article cards (client-side; "All" shows everything).
  // (Text search is a real Shopify search form that submits to /search.)
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-blog-category-nav] [data-filter-category]');
    if (!btn) return;
    e.preventDefault();
    var item = btn.closest('[data-filter-category]');
    var nav = item.closest('[data-blog-category-nav]');
    var section = nav.closest('[data-section-type="blog"]') || document;
    var selected = item.getAttribute('data-filter-category');

    nav.querySelectorAll('[data-filter-category]').forEach(function(li) {
      li.classList.toggle('inline-nav--active', li === item);
    });

    section.querySelectorAll('.article[data-category]').forEach(function(card) {
      var match = selected === '' || card.getAttribute('data-category') === selected;
      card.style.display = match ? '' : 'none';
    });
  });

  // Blog listing: pre-activate a category filter from ?category=<handle> in the URL
  // (used by the "Category posts" cards which link to /blogs/blog?category=...).
  (function() {
    var params = new URLSearchParams(window.location.search);
    var cat = params.get('category');
    if (!cat) return;
    var nav = document.querySelector('[data-blog-category-nav]');
    if (!nav) return;
    var item = nav.querySelector('[data-filter-category="' + cat + '"]');
    if (!item) return;
    (item.querySelector('a') || item).click();
  })();

  // Blog listing: live AJAX search (Shopify Predictive Search — matches title + body).
  // Fetches the "blog-search-results" section and swaps the article listing in place.
  (function() {
    var form = document.querySelector('[data-blog-search-form]');
    var input = document.querySelector('[data-blog-search-input]');
    var results = document.querySelector('[data-blog-results]');
    if (!form || !input || !results) return;

    var originalHTML = results.innerHTML;
    var debounceTimer = null;
    var lastQuery = null;
    var controller = null;

    function restoreAll() {
      clearTimeout(debounceTimer);
      if (controller) controller.abort();
      lastQuery = '';
      results.innerHTML = originalHTML;
      results.removeAttribute('aria-busy');
    }

    function runSearch(query) {
      query = query.trim();
      if (query.length < 2) { restoreAll(); return; }
      if (query === lastQuery) return;
      lastQuery = query;

      if (controller) controller.abort();
      controller = new AbortController();

      var url = '/search/suggest?q=' + encodeURIComponent(query) +
        '&resources[type]=article&resources[limit]=10&section_id=blog-search-results';

      results.setAttribute('aria-busy', 'true');

      fetch(url, { signal: controller.signal })
        .then(function(r) { return r.text(); })
        .then(function(html) {
          results.innerHTML = html.trim();
          results.removeAttribute('aria-busy');
        })
        .catch(function(err) {
          if (err.name !== 'AbortError') results.removeAttribute('aria-busy');
        });
    }

    function onType() {
      var q = input.value.trim();
      // Empty / too short → show all articles again immediately (no debounce)
      if (q.length < 2) { restoreAll(); return; }
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() { runSearch(q); }, 300);
    }

    input.addEventListener('input', onType);
    // 'search' fires on the native clear (x) button and on Enter for type=search
    input.addEventListener('search', onType);

    // Keep results in place on submit instead of navigating to /search
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      clearTimeout(debounceTimer);
      runSearch(input.value);
    });
  })();


  




  // Desktop full-page menu burger
  // Dispatch direct sur [data-drawer] avec null check — évite l'erreur de theme.js
  // qui n'a pas de null check sur querySelector("[data-drawer]").
  var desktopBurger = document.querySelector('[data-desktop-drawer-toggle]');
  if (desktopBurger) {
    desktopBurger.addEventListener('click', function() {
      var drawer = document.querySelector('[data-drawer]');
      if (drawer) {
        drawer.dispatchEvent(new CustomEvent('theme:drawer:toggle', {
          bubbles: false,
          detail: { button: desktopBurger }
        }));
      }
    });
  }

  // Klaviyo reviews carousel: after "Afficher plus", slide to the first newly loaded review.
  // Reviews are injected 5 at a time via AJAX, so we watch the track for new items
  // (event delegation because the button itself is also injected by Klaviyo).
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.kl_reviews__load_more_button .kl_reviews__button, .kl_reviews__load_more_button button');
    if (!btn) return;

    var container = btn.closest('.kl_reviews__list_container');
    var track = null;
    if (container) {
      track = container.querySelector(':scope > [role="status"]');
    }
    if (!track) {
      track = document.querySelector('.kl_reviews__list_container > [role="status"]');
    }
    if (!track) return;

    var prevCount = track.querySelectorAll('.kl_reviews__review_item').length;

    var fallback = setTimeout(function() { observer.disconnect(); }, 8000);

    var observer = new MutationObserver(function() {
      var items = track.querySelectorAll('.kl_reviews__review_item');
      if (items.length <= prevCount) return;

      var firstNew = items[prevCount];
      if (firstNew) {
        var delta = firstNew.getBoundingClientRect().left - track.getBoundingClientRect().left;
        track.scrollTo({ left: track.scrollLeft + delta, behavior: 'smooth' });
      }

      observer.disconnect();
      clearTimeout(fallback);
    });

    observer.observe(track, { childList: true });
  });


  // Product Apps section (Klaviyo reviews): hide the whole section when there are
  // neither reviews nor questions. Klaviyo prints both counts in the tab buttons:
  //   #kl_reviews_tabs__reviews_tab small   → reviews count
  //   #kl_reviews_tabs__questions_tab small → questions count
  // The widget is injected async, so we observe until the counts render.
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-section-type="product-apps"]'),
    function(section) {
      function getCount(tabId) {
        var tab = section.querySelector('#' + tabId) || document.getElementById(tabId);
        if (!tab) return null;
        var small = tab.querySelector('small');
        if (!small) return null;
        var n = parseInt(small.textContent.replace(/[^\d]/g, ''), 10);
        return isNaN(n) ? null : n;
      }

      function evaluate() {
        var reviews = getCount('kl_reviews_tabs__reviews_tab');
        var questions = getCount('kl_reviews_tabs__questions_tab');
        // Tabs not rendered yet — wait for the next mutation.
        if (reviews === null && questions === null) return;

        if ((reviews || 0) === 0 && (questions || 0) === 0) {
          section.style.display = 'none';
        } else {
          section.style.display = '';
        }
      }

      var settleTimer = null;
      function scheduleEvaluate() {
        clearTimeout(settleTimer);
        settleTimer = setTimeout(evaluate, 600);
      }

      var observer = new MutationObserver(scheduleEvaluate);
      observer.observe(section, { childList: true, subtree: true, characterData: true });

      // Initial pass + safety stop.
      scheduleEvaluate();
      setTimeout(function() { observer.disconnect(); }, 15000);
    }
  );


  // Product info: when there are no reviews, flag the form so CSS can hide the
  // reviews summary block and let the next block span two rows. We reuse the
  // Klaviyo reviews tab count (#kl_reviews_tabs__reviews_tab small) as the signal.
  // Same signal reveals the whole reviews section (hidden by default in CSS).
  (function() {
    var form = document.querySelector('product-info .form__width');
    var isDesignMode = window.Shopify && Shopify.designMode;

    function reviewsSection() {
      var anchor = document.getElementById('product-reviews');
      return anchor ? anchor.closest('.shopify-section') : null;
    }

    // In the theme editor, always reveal so the merchant can see/edit the section.
    if (isDesignMode) {
      var s = reviewsSection();
      if (s) s.classList.add('reviews-visible');
    }

    function reviewsCount() {
      var tab = document.getElementById('kl_reviews_tabs__reviews_tab');
      if (!tab) return null;
      var small = tab.querySelector('small');
      if (!small) return null;
      var n = parseInt(small.textContent.replace(/[^\d]/g, ''), 10);
      return isNaN(n) ? null : n;
    }

    function evaluate() {
      var count = reviewsCount();
      if (count === null) return false; // tabs not rendered yet
      if (form) {
        form.classList.toggle('no-reviews', count === 0);
        form.classList.toggle('has-reviews', count > 0 || isDesignMode);
      }
      var section = reviewsSection();
      if (section) section.classList.toggle('reviews-visible', count > 0 || isDesignMode);
      return true;
    }

    if (evaluate()) return;

    var settle = null;
    var observer = new MutationObserver(function() {
      clearTimeout(settle);
      settle = setTimeout(evaluate, 600);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    setTimeout(function() { observer.disconnect(); }, 15000);
  })();


  // Product page: flag #MainContent depending on whether the first section is a
  // shown image banner (hero with contributed media) or not. The hero only outputs
  // [data-section-type="hero"] when media is contributed, so we read it from the
  // first .shopify-section. Classes: product-has-banner | product-no-banner.
  (function() {
    if (!document.body.classList.contains('template-product')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var firstSection = main.querySelector(':scope > .shopify-section');
    var bannerShown = !!(firstSection && firstSection.querySelector('[data-section-type="hero"]'));
    main.classList.add(bannerShown ? 'product-has-banner' : 'product-no-banner');
  })();

  // Product reviews track: flag it as overflowing so CSS shows a FIXED right frame border
  // while it scrolls (4+ reviews), but lets the last card carry the right border when it fits
  // (fewer reviews) so the frame hugs the content instead of floating at the far edge.
  (function() {
    function updateReviewsOverflow() {
      document
        .querySelectorAll('#klaviyo-product-reviews-wrapper .kl_reviews__list_container > [role="status"]')
        .forEach(function(track) {
          track.classList.toggle('is-overflowing', track.scrollWidth - track.clientWidth > 1);
        });
    }
    updateReviewsOverflow();
    window.addEventListener('resize', updateReviewsOverflow);
    document.addEventListener('shopify:section:load', updateReviewsOverflow);
    // Klaviyo injects the reviews asynchronously — re-check for a short window on first load.
    var tries = 0;
    var timer = setInterval(function() {
      tries++;
      updateReviewsOverflow();
      if (tries > 20) clearInterval(timer);
    }, 500);
  })();

  // Ingredient slider: rows behave as accordions on tablet & mobile (<=1100px).
  document.addEventListener('click', function(e) {
    var label = e.target.closest('.ingredient-slide .ingredient-row__label');
    if (!label) return;
    if (window.matchMedia('(min-width: 1101px)').matches) return; // desktop: full table, no accordion
    var row = label.closest('.ingredient-row');
    if (!row) return;
    row.classList.toggle('is-open');

    // Recalculate the flickity height so the expanded/collapsed content isn't clipped.
    var slider = row.closest('slider-component');
    if (slider && slider.flkty) {
      requestAnimationFrame(function() { slider.flkty.resize(); });
    }
  });

  // Mobile slider nav (featured collection, blog listing, multicolumn, tab collections…):
  // prev/next scroll by one item. Finds the nearest slider up the tree so it works
  // even with several sliders in one section (e.g. tabs).
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('[data-collection-prev], [data-collection-next]');
    if (!btn) return;

    var slider = null;
    var scope = btn.parentElement;
    while (scope) {
      slider = scope.querySelector('[data-collection-slider]');
      if (slider) break;
      scope = scope.parentElement;
    }
    if (!slider) return;

    var items = slider.querySelectorAll('.grid-item');
    if (!items.length) items = slider.children;
    if (!items.length) return;

    // Work in offsetLeft coordinates, first item as the reference start. The scroll
    // target for item i is (item[i].offsetLeft - item[0].offsetLeft), which cancels the
    // slider's left padding AND every item's margin/gap.
    var base = items[0].offsetLeft;
    var isNext = btn.hasAttribute('data-collection-next');
    var current = slider.scrollLeft;
    var i;

    // Find the item nearest to the current start position, then step by one. Using the
    // nearest index (rather than a threshold vs. scrollLeft) stays correct even when the
    // slider is over-scrolled into the trailing space past the last item.
    var nearest = 0;
    var best = Infinity;
    for (i = 0; i < items.length; i++) {
      var d = Math.abs((items[i].offsetLeft - base) - current);
      if (d < best) { best = d; nearest = i; }
    }

    var idx = isNext ? Math.min(nearest + 1, items.length - 1) : Math.max(nearest - 1, 0);
    var maxScroll = slider.scrollWidth - slider.clientWidth;
    var dest = Math.max(0, Math.min(items[idx].offsetLeft - base, maxScroll));
    slider.scrollTo({ left: dest, behavior: 'smooth' });
  });

  // Disable prev/next arrows when the slider reaches its start/end.
  Array.prototype.forEach.call(
    document.querySelectorAll('[data-collection-slider]'),
    function(slider) {
      // Find the nav buttons associated with this slider (nearest ancestor holding them).
      var prev = null, next = null;
      var scope = slider.parentElement;
      while (scope) {
        prev = scope.querySelector('[data-collection-prev]');
        next = scope.querySelector('[data-collection-next]');
        if (prev || next) break;
        scope = scope.parentElement;
      }
      if (!prev && !next) return;

      function update() {
        if (slider.clientWidth === 0) return; // hidden (e.g. inactive tab)
        var maxScroll = slider.scrollWidth - slider.clientWidth - 1;
        if (prev) prev.toggleAttribute('disabled', slider.scrollLeft <= 0);
        if (next) next.toggleAttribute('disabled', slider.scrollLeft >= maxScroll);
      }

      slider.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      window.addEventListener('load', update);
      update();
    }
  );

  // Partners carousel: seamless auto marquee (right to left). When the pointer is
  // over the carousel, it slides toward the side the mouse is on at a constant
  // speed. One item (capped at 90vw) per view on mobile.
  function initPartnersCarousel(carousel) {
      if (carousel.dataset.partnersInit) return;
      carousel.dataset.partnersInit = '1';

      var track = carousel.querySelector('[data-partners-track]');
      if (!track) return;

      var originalHTML = track.innerHTML;
      var slidesDesktop = parseFloat(carousel.getAttribute('data-slides')) || 2.5;
      var gap = parseFloat(carousel.getAttribute('data-gap')) || 0;
      var speed = parseFloat(carousel.getAttribute('data-speed')) || 5;

      var offset = 0;
      var setWidth = 0;
      var hovering = false;
      var pointerCentered = 0; // -1 (far left) .. 1 (far right)
      var canHover = window.matchMedia('(hover: hover)').matches;

      // Drag-to-slide state (mouse + touch, via Pointer Events)
      var dragging = false;
      var dragStartX = 0;
      var dragStartOffset = 0;
      var dragPointerId = null;

      function wrapOffset() {
        if (setWidth > 0) {
          while (offset <= -setWidth) offset += setWidth;
          while (offset >= 0) offset -= setWidth;
        }
      }

      function build() {
        track.innerHTML = originalHTML;
        var originals = Array.prototype.slice.call(track.children);
        var count = originals.length;
        if (count === 0) return;

        var isMobile = window.matchMedia('(max-width: 991px)').matches;
        var visible = isMobile ? 1 : slidesDesktop;
        var vw = carousel.clientWidth;
        var slideWidth = (vw - gap * (visible - 1)) / visible;
        // Mobile: cap each item at 90vw (not full width)
        if (isMobile) slideWidth = vw * 0.9;

        originals.forEach(function(el) { el.style.width = slideWidth + 'px'; });

        // Repeating unit width (each slide has margin-right = gap)
        setWidth = count * (slideWidth + gap);

        // Duplicate the set enough times to cover the viewport seamlessly
        var copies = Math.max(2, Math.ceil((vw * 2) / setWidth) + 1);
        for (var c = 1; c < copies; c++) {
          originals.forEach(function(el) {
            var clone = el.cloneNode(true);
            clone.setAttribute('aria-hidden', 'true');
            track.appendChild(clone);
          });
        }
        offset = 0;
      }

      function velocity() {
        // Constant speed; only the direction changes.
        var step = speed * 0.1;
        if (hovering) {
          // mouse on left half → slide left (offset increases); right half → slide right
          var dir = pointerCentered < 0 ? 1 : -1;
          return dir * step;
        }
        // default: right to left (offset decreases)
        return -step;
      }

      function tick() {
        // Stop the loop once the section is removed (e.g. Shopify editor reload)
        if (!document.body.contains(carousel)) return;
        if (!dragging) {
          offset += velocity();
          wrapOffset();
          track.style.transform = 'translateX(' + offset + 'px)';
        }
        requestAnimationFrame(tick);
      }

      // Desktop hover-follow — only on real hover/mouse devices (so touch doesn't glitch
      // from synthetic mouse events), and never while dragging.
      carousel.addEventListener('mousemove', function(e) {
        if (!canHover || dragging) return;
        var rect = carousel.getBoundingClientRect();
        var rel = (e.clientX - rect.left) / rect.width;
        pointerCentered = Math.max(-1, Math.min(1, rel * 2 - 1));
        hovering = true;
      });
      carousel.addEventListener('mouseleave', function() { hovering = false; });

      // Drag-to-slide (mouse + touch). We DON'T grab the pointer on pointerdown; we wait
      // until the gesture is clearly horizontal (past a small threshold). A vertical
      // gesture is left to the browser, so page scrolling on mobile stays native and
      // smooth (no glitch). Only a confirmed horizontal drag pauses the marquee.
      var maybeDrag = false;
      var dragStartY = 0;
      var DRAG_THRESHOLD = 8;

      function beginDrag() {
        dragging = true;
        hovering = false;
        try { carousel.setPointerCapture(dragPointerId); } catch (err) {}
        carousel.classList.add('is-dragging');
      }

      carousel.addEventListener('pointerdown', function(e) {
        maybeDrag = true;
        dragStartX = e.clientX;
        dragStartY = e.clientY;
        dragStartOffset = offset;
        dragPointerId = e.pointerId;
      });
      carousel.addEventListener('pointermove', function(e) {
        if (dragging) {
          offset = dragStartOffset + (e.clientX - dragStartX);
          wrapOffset();
          track.style.transform = 'translateX(' + offset + 'px)';
          return;
        }
        if (!maybeDrag) return;
        var dx = e.clientX - dragStartX;
        var dy = e.clientY - dragStartY;
        if (Math.abs(dx) > DRAG_THRESHOLD && Math.abs(dx) >= Math.abs(dy)) {
          beginDrag();                       // horizontal → take over as a drag
          offset = dragStartOffset + dx;
          wrapOffset();
          track.style.transform = 'translateX(' + offset + 'px)';
        } else if (Math.abs(dy) > DRAG_THRESHOLD) {
          maybeDrag = false;                 // vertical → let the page scroll
        }
      });
      function endDrag() {
        maybeDrag = false;
        if (!dragging) return;
        dragging = false;
        carousel.classList.remove('is-dragging');
        if (dragPointerId !== null) {
          try { carousel.releasePointerCapture(dragPointerId); } catch (err) {}
          dragPointerId = null;
        }
      }
      carousel.addEventListener('pointerup', endDrag);
      carousel.addEventListener('pointercancel', endDrag);

      // Rebuild only when the WIDTH changes. On mobile, scrolling hides/shows the URL bar
      // which fires resize with a new height only — rebuilding then reset the track and
      // caused the flicker. Ignoring height-only resizes fixes it.
      var resizeTimer;
      var lastWidth = window.innerWidth;
      window.addEventListener('resize', function() {
        if (window.innerWidth === lastWidth) return;
        lastWidth = window.innerWidth;
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(build, 200);
      });

      build();
      requestAnimationFrame(tick);
  }

  function initAllPartners(root) {
    var scope = root || document;
    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-partners-carousel]'),
      initPartnersCarousel
    );
  }

  initAllPartners();

  // Re-init when Shopify re-renders the section in the theme editor
  document.addEventListener('shopify:section:load', function(e) {
    initAllPartners(e.target);
  });

  // Klaviyo featured reviews carousel: Swiper (css-mode) freezes inline slide widths
  // + margin-right computed before our CSS widens the container, leaving a partial
  // slide peeking. We re-size each slide to an exact fraction of the viewport and
  // zero the margins, then re-apply on resize and whenever Swiper mutates the DOM.
  function slidesPerView(width) {
    if (width < 750) return 1;
    if (width < 990) return 2;
    return 4;
  }

  function fixKlaviyoCarousel(swiper) {
    var wrapper = swiper.querySelector('.swiper-wrapper');
    if (!wrapper) return;
    var slides = wrapper.querySelectorAll(':scope > .swiper-slide');
    if (!slides.length) return;

    var perView = slidesPerView(swiper.clientWidth);
    var slideWidth = swiper.clientWidth / perView;

    swiper._fixing = true;
    Array.prototype.forEach.call(slides, function(slide) {
      slide.style.width = slideWidth + 'px';
      slide.style.marginRight = '0px';
      slide.style.marginLeft = '0px';
    });
    // Let the mutation from our own writes settle before re-observing
    requestAnimationFrame(function() { swiper._fixing = false; });
  }

  function initKlaviyoCarousels(root) {
    var scope = root || document;
    Array.prototype.forEach.call(
      scope.querySelectorAll('.kl_reviews__carousel .swiper'),
      function(swiper) {
        if (swiper._klFixInit) {
          fixKlaviyoCarousel(swiper);
          return;
        }
        swiper._klFixInit = true;

        fixKlaviyoCarousel(swiper);

        // Re-apply when Swiper rewrites slide widths/margins
        var observer = new MutationObserver(function() {
          if (swiper._fixing) return;
          fixKlaviyoCarousel(swiper);
        });
        var wrapper = swiper.querySelector('.swiper-wrapper');
        if (wrapper) {
          observer.observe(wrapper, {
            attributes: true,
            attributeFilter: ['style'],
            subtree: true,
            childList: true
          });
        }
      }
    );
  }

  // The widget is injected asynchronously, so retry for a short window on first load.
  var klTries = 0;
  var klTimer = setInterval(function() {
    klTries++;
    if (document.querySelector('.kl_reviews__carousel .swiper')) {
      initKlaviyoCarousels();
      clearInterval(klTimer); // found + observing; stop polling
    }
    if (klTries > 20) clearInterval(klTimer);
  }, 500);

  var klResizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(klResizeTimer);
    klResizeTimer = setTimeout(function() { initKlaviyoCarousels(); }, 200);
  });

  document.addEventListener('shopify:section:load', function(e) {
    setTimeout(function() { initKlaviyoCarousels(e.target); }, 300);
  });

  // Hide .bundle-card__review-wrapper when Klaviyo renders no rating (no reviews).
  function bundleReviewCount(widget) {
    if (!widget) return null;
    // Klaviyo hydrates a button with a label ("44 avis") and an aria-label
    // ("4.9 étoiles, 44 évaluations"). Until hydrated, return null (unknown).
    var btn = widget.querySelector('.kl_reviews__star_rating_widget');
    if (!btn) return null;
    var label = widget.querySelector('.kl_reviews__star_rating_widget__label');
    var text = (label && label.textContent) || btn.getAttribute('aria-label') || '';
    var nums = text.replace(/ /g, ' ').match(/\d[\d.,]*/g);
    if (!nums || !nums.length) return null;
    // Last number in the string is the review count (rating comes first).
    var count = parseInt(nums[nums.length - 1].replace(/[.,]/g, ''), 10);
    return isNaN(count) ? null : count;
  }

  function evaluateBundleReview(wrapper) {
    var widget = wrapper.querySelector('.klaviyo-star-rating-widget');
    var count = bundleReviewCount(widget);
    // Hidden by default; only show once hydrated with more than 0 reviews.
    var show = count !== null && count > 0;
    wrapper.classList.toggle('bundle-card__review-wrapper--empty', !show);
  }

  function initBundleReviews(root) {
    var scope = root || document;
    var wrappers = scope.querySelectorAll('.bundle-card__review-wrapper');
    wrappers.forEach(function(wrapper) {
      var widget = wrapper.querySelector('.klaviyo-star-rating-widget');
      if (!widget) {
        wrapper.classList.add('bundle-card__review-wrapper--empty');
        return;
      }
      evaluateBundleReview(wrapper);
      var obs = new MutationObserver(function() { evaluateBundleReview(wrapper); });
      obs.observe(widget, { childList: true, subtree: true });
    });
  }

  initBundleReviews();
  // Klaviyo hydrates asynchronously; re-check for a short window after load.
  var bundleTries = 0;
  var bundleTimer = setInterval(function() {
    bundleTries++;
    document.querySelectorAll('.bundle-card__review-wrapper').forEach(evaluateBundleReview);
    if (bundleTries > 20) clearInterval(bundleTimer);
  }, 500);

  document.addEventListener('shopify:section:load', function(e) {
    setTimeout(function() { initBundleReviews(e.target); }, 300);
  });

  // Tab collections: anchor support. Each .tab-content has id = its label handle
  // (set in section-tab-collections.liquid). Navigating to #that-id activates the
  // matching tab and scrolls to it — a hidden tab can't be scrolled to on its own.
  function activateTabFromHash() {
    var hash = decodeURIComponent((window.location.hash || '').slice(1));
    if (!hash) return;
    var content = document.getElementById(hash);
    if (!content || !content.classList.contains('tab-content')) return;
    var tabs = content.closest('tabs-component');
    if (!tabs) return;
    var idx = (content.className.match(/tab-content-(\d+)/) || [])[1];
    if (idx == null) return;
    var link = tabs.querySelector('.tab-link[data-tab="' + idx + '"]');
    if (link && !link.classList.contains('current')) link.click();
    requestAnimationFrame(function() {
      (content.closest('section') || tabs).scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }
  window.addEventListener('hashchange', activateTabFromHash);
  window.addEventListener('load', activateTabFromHash);
  activateTabFromHash();

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
